import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import MobileTopBar from "./MobileTopBar";
import GlobalDateFilter from "./GlobalDateFilter";

const STORAGE_KEY = "uc.sidebar.collapsed";

export default function Layout({ activeTab, onTabChange, darkMode, onToggleDark, user, onSignOut, dateFilter, onDateFilterChange, children }) {
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  });
  useEffect(() => {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
  }, [collapsed]);

  return (
    <div className="min-h-screen bg-brand-pale-gray dark:bg-[var(--bg-page)] flex">
      <Sidebar
        activeTab={activeTab}
        onChange={onTabChange}
        darkMode={darkMode}
        onToggleDark={onToggleDark}
        user={user}
        onSignOut={onSignOut}
        collapsed={collapsed}
        onToggleCollapsed={() => setCollapsed((v) => !v)}
      />
      <div className="flex-1 min-w-0">
        <MobileTopBar
          activeTab={activeTab}
          onChange={onTabChange}
          darkMode={darkMode}
          onToggleDark={onToggleDark}
        />
        {dateFilter && onDateFilterChange && (
          <GlobalDateFilter value={dateFilter} onChange={onDateFilterChange} />
        )}
        <main className="max-w-[1600px] mx-auto px-6 py-6">{children}</main>
      </div>
    </div>
  );
}
